module.exports = __webpack_public_path__ + "static/media/sway-prototype01.d09ffc13.jpg";